module.exports = __webpack_public_path__ + "static/media/Produtos6.ede40bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos6.png
// module id = 2006
// module chunks = 0